export var NBAComponentType;

(function (NBAComponentType) {
  NBAComponentType["DEFAULT"] = "default";
  NBAComponentType["COLLAPSIBLE"] = "collapsible";
  NBAComponentType["EXPERIMENT_CARD"] = "experiment";
})(NBAComponentType || (NBAComponentType = {}));